import { useEffect, useRef } from "react";
import L from "leaflet";
import { pinHtml } from "@/lib/categories";

export default function MiniMap({ lat, lng, category, className }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || lat == null || lng == null) return;
    const map = L.map(elRef.current, {
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      boxZoom: false,
      keyboard: false,
      touchZoom: false,
      tap: false,
    }).setView([lat, lng], 16);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
    }).addTo(map);

    L.marker([lat, lng], {
      icon: L.divIcon({
        html: pinHtml(category),
        className: "go-pin-wrap",
        iconSize: [32, 32],
        iconAnchor: [16, 30],
      }),
    }).addTo(map);

    mapRef.current = map;
    setTimeout(() => map.invalidateSize(), 200);

    return () => {
      map.remove();
      mapRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lat, lng]);

  return <div ref={elRef} className={className} data-testid="mini-map" />;
}
